import { MouseEvent, SyntheticEvent, useCallback, useState } from 'react';
import { EHeaderElement, THeaderElement } from './useHeader.types';

const useHeader = () => {
  const [currentOpenElement, setCurrentOpenElement] = useState<
    THeaderElement | HTMLElement | undefined
  >();
  const [isToastOpen, setIsToastOpen] = useState(false);

  const openBurgerDrawer = useCallback(() => {
    setCurrentOpenElement(EHeaderElement.BURGER);
  }, []);

  const openFormDrawer = useCallback(() => {
    setCurrentOpenElement(EHeaderElement.FORM);
  }, []);

  const openDropdownMenu = useCallback((event: MouseEvent<HTMLElement>) => {
    setCurrentOpenElement(event.currentTarget);
  }, []);

  const openLogoutModal = useCallback(() => {
    setCurrentOpenElement(EHeaderElement.LOGOUT);
  }, []);

  const closeElement = () => setCurrentOpenElement(undefined);
  const openToast = () => setIsToastOpen(true);
  const closeToast = (event?: SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setIsToastOpen(false);
  };

  const openProfileDrawer = useCallback(() => {
    setCurrentOpenElement(EHeaderElement.PROFILE);
  }, []);

  const openNotifications = useCallback(
    (
      eventOrElement: React.MouseEvent<HTMLButtonElement> | HTMLButtonElement,
    ) => {
      const element =
        eventOrElement instanceof HTMLElement
          ? eventOrElement
          : eventOrElement.currentTarget;

      setCurrentOpenElement(element);
    },
    [],
  );

  const openNotificationsDrawer = useCallback(() => {
    setCurrentOpenElement(EHeaderElement.NOTIFICATIONS_Drawer);
  }, []);

  const isBurgerDrawerOpen = currentOpenElement === EHeaderElement.BURGER;
  const isFormDrawerOpen = currentOpenElement === EHeaderElement.FORM;
  const isDropdownMenuOpen =
    currentOpenElement instanceof HTMLElement &&
    currentOpenElement.id.includes(EHeaderElement.USER_BOX);
  const isLogoutModalOpen = currentOpenElement === EHeaderElement.LOGOUT;
  const isProfileDrawerOpen = currentOpenElement === EHeaderElement.PROFILE;
  const isNotificationsOpen =
    currentOpenElement instanceof HTMLElement &&
    currentOpenElement.id.includes(EHeaderElement.NOTIFICATIONS);
  const isNotificationsDrawerOpen =
    currentOpenElement === EHeaderElement.NOTIFICATIONS_Drawer;

  return {
    currentOpenElement,
    openBurgerDrawer,
    openFormDrawer,
    openDropdownMenu,
    openLogoutModal,
    openToast,
    openProfileDrawer,
    openNotifications,
    openNotificationsDrawer,
    closeElement,
    closeToast,
    isBurgerDrawerOpen,
    isFormDrawerOpen,
    isDropdownMenuOpen,
    isLogoutModalOpen,
    isToastOpen,
    isProfileDrawerOpen,
    isNotificationsOpen,
    isNotificationsDrawerOpen,
  };
};

export default useHeader;
